import React, { useEffect, useState } from 'react';
import { useDatabase } from '../../../db/DatabaseProvider';
import { useBaseCurrency } from '../../../db/hooks/useLookupData';
import { Clock, Calendar, CheckCircle2 } from 'lucide-react';

interface Props {
  customerId: string;
}

export function CustomerTabAttentions({ customerId }: Props) {
  const db = useDatabase();
  const { currencySymbol } = useBaseCurrency();
  const [attentions, setAtenciones] = useState<any[]>([]);

  useEffect(() => {
    if (!db || !customerId) return;
    const sub = db.customer_packages.find({ selector: { customer_id: customerId } }).$.subscribe(docs => {
      const allAtenciones: any[] = [];
      docs.forEach(d => {
        if (d.attentions) {
          d.attentions.forEach((a: any) => {
            allAtenciones.push({
              ...a,
              paqueteNombre: d.package_name
            });
          });
        }
      });
      // Sort by date desc
      allAtenciones.sort((a, b) => {
        const dateA = new Date(a.attention_date || 0).getTime();
        const dateB = new Date(b.attention_date || 0).getTime();
        return dateB - dateA;
      });
      setAtenciones(allAtenciones);
    });
    return () => sub.unsubscribe();
  }, [db, customerId]);

  return (
    <div className="space-y-4 animate-fade-in">
      <h3 className="text-lg font-bold text-text-primary">Historial de Atenciones</h3>
      {attentions.length === 0 ? (
        <div className="text-center p-8 bg-surface border border-dashed border-border rounded-xl">
          <Clock className="w-8 h-8 text-text-tertiary mx-auto mb-2" />
          <p className="text-sm text-text-secondary">No hay atenciones registradas para este cliente.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {attentions.map((atn) => {
            const dateStr = atn.attention_date;
            const commAmt = atn.commission_amount ?? 0;

            return (
              <div key={atn.id} className="bg-surface border border-border rounded-xl p-4 flex flex-col sm:flex-row justify-between sm:items-center gap-3">
                <div>
                  <div className="flex items-center gap-2">
                    <CheckCircle2 className="w-4 h-4 text-emerald-500" />
                    <span className="font-bold text-sm text-text-primary">{atn.paqueteNombre}</span>
                  </div>
                  <div className="text-xs text-text-secondary mt-1 flex items-center gap-2">
                    <Calendar className="w-3.5 h-3.5" />
                    {dateStr ? new Date(dateStr).toLocaleString('es-ES') : ''}
                  </div>
                </div>
                <div className="text-right">
                  <span className="text-xs font-semibold text-text-secondary block">Monto Comisión: {currencySymbol}{commAmt.toFixed(2)}</span>
                  <span className="text-xs text-text-tertiary">{atn.notes}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
